import angular from 'angular';
import {DrawViewComponent} from './draw-view.component';

export const drawViewModule = angular.module('slviz.drawView', [])
    .component('drawView', DrawViewComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/views/draw-view/index.js